export enum urls {
  PIX_KEYS = '/abertura-conta-pf/pix/key',
  GET_CODIGO_VALIDAR = '/abertura-conta-pf/indique-ganhe/codigo/validar',
  PUT_CODIGO_INDICAR = '/abertura-conta-pf/indique-ganhe/codigo/indicar',
  POST_CONTA_MEI = '/abertura-conta-pf/fichas/mei',
  PUT_CONTA_GLOBAL = '/abertura-conta-pf/fichas/conta-global',
  GET_LOYALTY_TERMS = '/abertura-conta-pf/toggle/opt-in-loyalty',
  PUT_LOYALTY = '/abertura-conta-pf/fichas/loyalty',
  PUT_KIDS = '/abertura-conta-pf/fichas/kids',
}
